import { BlogSection } from '@/types/blog';

export const intro: BlogSection = {
  id: 'intro',
  title: 'Das Dogma und seine Grenzen',
  content: `
<p class="text-lg font-medium mb-6">
  "Finde deine Nische!" – dieses Mantra der Business-Welt hat Märkte erobert, Karrieren gebaut, Expertise geschaffen. Für Spezialisten, die tief graben und ein eng umrissenes Feld beherrschen, ist es der goldene Pfad zum Erfolg.
</p>

<p class="mb-4">
  Doch unsere Zeit stellt eine andere Frage: Was, wenn die drängendsten Herausforderungen nicht durch tiefere Spezialisierung gelöst werden, sondern durch die Fähigkeit, Silos aufzubrechen und Verbindungen herzustellen? Was, wenn die wertvollste Führungskompetenz nicht das Detail-Wissen ist, sondern das Verstehen komplexer Systeme?
</p>

<p class="mb-4">
  Die Antwort liegt in einem Führungsstil, der das Nischen-Dogma hinterfragt: <strong>Katalysator-Führung</strong>. Sie wirkt nicht durch Vertiefung, sondern durch Vernetzung. Nicht durch Kontrolle, sondern durch das Schaffen von Bedingungen, unter denen Organisationen als lebendige Systeme zur Lösung finden.
</p>
  `,
};
